import { text } from '@onbeam/business-styled-system/patterns';

export const tabButtonStyle = text({
  style: 'body-lg',
  transition: 'colors',
  cursor: 'pointer',
  color: 'mono.tertiary',

  _supportsHover: {
    _hover: {
      color: 'mono.primaryBg',
    },
  },
  _focusVisible: {
    color: 'mono.primaryBg',
  },
  _active: {
    color: 'mono.primaryBg',
  },
});
